import Notification, { NotificationProps } from '.';
import React from 'react';

// This object should contain a mock value for each required prop of this component
export const requiredProps: NotificationProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as NotificationProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      children: [
        <Notification.TextLabel key="0">label</Notification.TextLabel>,
        <Notification.CloseButton key="1" />,
      ],
    } as NotificationProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
